import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {ArrowUpward, CalendarMonth, CheckCircle} from "@mui/icons-material";
import {Button, InputAdornment, TextField} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import NotifyOptional from "./NotifyOptional";
import Box from "@mui/material/Box";
import {MobileDateTimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {DemoItem} from "@mui/x-date-pickers/internals/demo";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import isNull from "../../../../../../mixin/isNull";
import LoadingData from "../common/LoadingData";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import parameter from "../../../../../../enum/parameter";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const eventDispatcher = useEventDispatcher();
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();
    const reservesInput = useRef();
    const arrivedAtInput = useRef();
    const leftAtInput = useRef();
    const nextOrderOrderCommentInput = useRef();
    const [loading, setLoading] = useState(false);
    const reservesRef = useRef();
    const arrivalHourRef = useRef();
    const leftHourRef = useRef();

    useEffect(() => {
        qualityInspectionRepository.findOneById(qualityInspectionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(qualityInspection)) return;

        eventDispatcher.launcher("reserves");

        setTimeout(() => eventDispatcher.launcher("arrival-hour"), parameter.POPUP_TIME);
        setTimeout(() => eventDispatcher.launcher("left-hour"), parameter.POPUP_TIME * 2);
    }, [JSON.stringify(qualityInspection)]);

    const nextStep = async () => {
        setLoading(true);

        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_DELIVERY,
                delivered_without_reservation: reservesInput.current.value.length === 0,
                delivered_comment: reservesInput.current.value.length > 0 ? reservesInput.current.value : null,
                arrived_at: arrivedAtInput.current,
                left_at: leftAtInput.current,
                request_next_order: nextOrderOrderCommentInput.current.value.length > 0
            },
            order: {
                order_comment: nextOrderOrderCommentInput.current.value.length > 0 ? nextOrderOrderCommentInput.current.value : null
            }
        });

        if (!res) setLoading(false);
    }

    if (isNull(qualityInspection)) return <LoadingData/>;

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyOptional/>
                </Box>
                <Box px={2}>
                    <Box mt={5}>
                        <TextField
                            fullWidth
                            label={"Réserves émises par le sociétaire"}
                            multiline
                            rows={4}
                            inputRef={reservesInput}
                            ref={reservesRef}
                            data-test="input-beneficiary-reservation"
                        />
                        <PopperWrapper
                            elementRef={reservesRef}
                            placement={"bottom"}
                            content={"Si le sociétaire émet des reserves, complétez ce champs"}
                            triggeringEvent={"reserves"}
                            autoCloseAfter={parameter.POPUP_TIME}
                            displayCloseButton={false}
                            contentColor={parameter.POPUP_COLOR}
                            icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                        />
                    </Box>
                    <Box mt={2}>
                        <DemoItem label={"Heure d'arrivée"}>
                            <MobileDateTimePicker
                                ampm={false}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        InputProps: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CalendarMonth/>
                                                </InputAdornment>
                                            ),
                                        },
                                        "data-test": "input-arrived-at"
                                    }
                                }}
                                defaultValue={dayjs(new Date(qualityInspection.getArrivedAt()))}
                                onChange={(val) => arrivedAtInput.current = dayjs(val).toISOString()}
                                ref={arrivalHourRef}
                            />
                        </DemoItem>
                        <PopperWrapper
                            elementRef={arrivalHourRef}
                            placement={"bottom"}
                            content={"Si votre heure d'arrivée ne correspond pas, corrigez-la"}
                            triggeringEvent={"arrival-hour"}
                            autoCloseAfter={parameter.POPUP_TIME}
                            displayCloseButton={false}
                            contentColor={parameter.POPUP_COLOR}
                            icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                        />
                    </Box>
                    <Box mt={2}>
                        <DemoItem label={"Heure de départ"}>
                            <MobileDateTimePicker
                                ampm={false}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        InputProps: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CalendarMonth/>
                                                </InputAdornment>
                                            ),
                                        },
                                        "data-test": "input-left-at"
                                    }
                                }}
                                defaultValue={dayjs(new Date())}
                                onChange={(val) => leftAtInput.current = dayjs(val).toISOString()}
                                ref={leftHourRef}
                            />
                        </DemoItem>
                        <PopperWrapper
                            elementRef={leftHourRef}
                            placement={"bottom"}
                            content={"Si votre heure de départ (du lieu d'intervention) ne correspond pas, corrigez-la"}
                            triggeringEvent={"left-hour"}
                            autoCloseAfter={parameter.POPUP_TIME}
                            displayCloseButton={false}
                            contentColor={parameter.POPUP_COLOR}
                            icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                        />
                    </Box>
                    <Box mt={5}>
                        <TextField
                            fullWidth
                            label={"Déclarez vos travaux supplémentaires"}
                            multiline
                            rows={4}
                            inputRef={nextOrderOrderCommentInput}
                            data-test="input-next-order-comment"
                        />
                    </Box>
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading}
                    data-test="button-next-step"
                >
                    Envoyer le SMS
                </Button>
            </Footer>
        </>
    )
}